module DropDownBox {

    let editableLabelHTML = `
<a class="btn btn-primary btn-select btn-select-light">
    <input type="hidden" class="ddInputField btn-select-input" id="" name="" value="" />
    <span class="btn-select-value">`+ localizer["DropDownBoxSelectItem"] +`</span>
    <span class='btn-select-arrow glyphicon glyphicon-chevron-down'></span>
    <ul class="ddOptions">
    </ul>
</a>`;


    export function Create(onChange: (newValue: string) => void): JQuery {
        var element = $(editableLabelHTML);
        element.find(".ddInputField").change(() => onChange(element.find(".ddInputField").val()));
        return element;
    }

    export function AddOption(element: JQuery, option : string, selected : boolean)
    {
        var optionElement = $('<li ' + (selected ? 'class="selected">' : '>') + option + '</li>');
        element.find(".ddOptions").append(optionElement);
        if (selected) {
            element.find(".ddInputField").val(option);
            element.find(".btn-select-value").html(option);
        }
    }
}